import { Routes } from '@angular/router';
import { AuthGuard } from '@auth/guards/auth.guard';

export const appRoutes: Routes = [
  {
    path: 'personal-account',
    loadComponent: () =>
      import('./shared/layout/personal-layout/personal-layout.component').then((m) => m.PersonalLayoutComponent),
    canActivate: [AuthGuard],
    loadChildren: () => import('./page/personal-account/personal-account.routes').then((m) => m.personalAccountRoutes),
  },
  {
    path: 'authentication',
    loadComponent: () => import('./shared/layout/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'map',
    loadComponent: () => import('./features/map/map.component').then((m) => m.MapComponent),
  },
  {
    path: 'travel-abroad',
    loadComponent: () =>
      import('./features/travel-abroad/travel-abroad.component').then((m) => m.TravelAbroadComponent),
  },
  {
    path: 'diaspora-abroad',
    loadComponent: () =>
      import('@features/diaspora-abroad/diaspora-abroad.component').then((m) => m.DiasporaAbroadComponent),
    loadChildren: () => import('@features/diaspora-abroad/diaspora.routes').then((m) => m.diasporaRoutes),
  },
  {
    path: 'internal-migration',
    loadChildren: () =>
      import('@features/internal-migration/internal-migration.routes').then((m) => m.internalMigrationRoutes),
  },
  {
    path: 'role-selection',
    loadComponent: () =>
      import('./auth/components/role-selection/role-selection.component').then((m) => m.RoleSelectionComponent),
  },
  {
    path: 'page502',
    loadComponent: () => import('./shared/components/page502/page502.component').then((m) => m.Page502Component),
  },
  {
    path: 'pea-agency-decision',
    loadComponent: () =>
      import('@features/pea-agency-decision/pea-agency-decision.component').then((m) => m.PeaAgencyDecisionComponent),
  },

  {
    path: '',
    loadComponent: () => import('./shared/layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
    children: [
      { path: '', redirectTo: '/main', pathMatch: 'full' },
      {
        path: 'main',
        loadChildren: () => import('./page/main/main.routes').then((m) => m.mainRoutes),
      },
      {
        path: 'ethnic-migration',
        loadChildren: () =>
          import('@features/ethnic-migration/ethnic-migration.routes').then((m) => m.ethnicMigrationRoutes),
      },
      {
        path: '**',
        loadComponent: () => import('./auth/components/page404/page404.component').then((m) => m.Page404Component),
      },
    ],
  },
];
